import Vue from '@/system/main';
import seriesMX from './series';
import facturasMX from './facturas';

export default {
	async setStatus(id, value, text = false) {
		const result = await Vue.$gestios.items('presupuestos').edit({
			id,
			params: {
				PresupuestoEstado: value
			}
		});

		if (result.ok) {
			if (text) {
				Vue.$message.success(`El presupuesto a cambiado a ${text}`);
			} else {
				Vue.$message.success('Estado del presupuesto cambiado correctamente');
			}
			return true;
		}

		return false;
	},
	async renderPDF(item) {
		const hide = Vue.$message.loading({ content: 'Generando PDF...', key: 'renderBudgetPDF' });
		const upload = await Vue.$lambda.get(`budget/render/${item._EntityId}`);

		if (upload.ok) {
			Vue.$message.success({ content: 'Documento PDF generado correctamente', key: 'renderBudgetPDF', duration: 2 });

			Vue.$gestios.$cache.items('presupuestos').edit({ id: item._EntityId, params: upload.data });

			return upload;
		}

		hide();
		Vue.$toast.error(`No se pudo generar el documento. ${upload.message}`);

		return upload;
	},
	async budgetToInvoice(item) {
		const getSerie = await Vue.$gestios.items('series').get(item._EntityId);
		const hide = Vue.$message.loading({ content: 'Creando factura...', key: 'budgetToInvoice' });

		if (getSerie.ok) {
			const serie = getSerie.data;

			const series = seriesMX.parseSerial(serie);

			const params = {
				Empresa: item.Empresa._EntityId,
				Serie: serie._EntityId,
				FacturaSerie: series.serial,

				FacturaEstado: 0,
				FacturaTotal: item.PresupuestoTotal,
				FacturaSubtotal: item.PresupuestoSubtotal,
				FacturaRetenciones: item.PresupuestoRetenciones,
				FacturaIVA: item.PresupuestoIVA,
				FacturaFecha: Vue.$moment().format('YYYY-MM-DD'),
				FacturaObservaciones: item.PresupuestoObservaciones,

				EmpresaNombre: item.EmpresaNombre,
				EmpresaCP: item.EmpresaCP,
				EmpresaCIF: item.EmpresaCIF,
				EmpresaLocalidad: item.EmpresaLocalidad,
				EmpresaProvincia: item.EmpresaProvincia,
				EmpresaPais: item.EmpresaPais,
				EmpresaDomicilioSocial: item.EmpresaDomicilioSocial
			};

			params.Conceptos = JSON.stringify(
				item.Conceptos.map((c) => ({
					Cantidad: c.Cantidad,
					Concepto: c.Concepto,
					Producto: c.Producto.key ? c.Producto.key : null,
					Precio: c.Precio,
					Descuento: c.Descuento
				}))
			);

			params.Vencimientos = JSON.stringify([{
				VencimientoFecha: Vue.$moment().format('YYYY-MM-DD'),
				VencimientoImporte: item.PresupuestoTotal
			}]);

			const add = await Vue.$gestios.items('facturas').add({ params, view: 'facturasList' });

			if (add.ok) {
				if (Vue.id === 0) await seriesMX.editSerialValue(item.Serie);
				await facturasMX.renderPDF(add.data);

				hide();
				Vue.$toast.success('Factura creada');

				return true;
			}
		}

		hide();
		Vue.$toast.error('Ocurrió un error al generar la factura');

		return false;
	}
};
